// extracted by mini-css-extract-plugin
module.exports = {"line":"footer-module--line--6Z_Wg","message":"footer-module--message--1GWrp"};